import { render, staticRenderFns } from "./TenderSteps.vue?vue&type=template&id=2fcc7c91&scoped=true"
import script from "./TenderSteps.vue?vue&type=script&lang=js"
export * from "./TenderSteps.vue?vue&type=script&lang=js"
import style0 from "./TenderSteps.vue?vue&type=style&index=0&id=2fcc7c91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc7c91",
  null
  
)

export default component.exports